export class SheetDetails {
  constructor(
    private _type?: string,
    private _bankName: string = "",
    private _bankCode: string = null,
    private _formJCompany: string = "",
    private _maker: string = "",
    private _mbbMaster?: number,
    private _otherBankMaster?: number,
    private _branchName?: string,
    private _glCode: string = null,
    private _accountDetails?: string,
    private _customerName?: string,
    private _checker: string = "",
    private _lineAmount?: number,
    private _cashInOffice?: string,
    private _remark?: string,
    private _ticket: string = "",
    private _proceed: string = "",
    // private _checker: string = "",
    private _timestamp?: string,
    private _phone: string = null,
    private _whatasppLink: string = null,
    private _voucher: string = null,
    private _voucherDate: string = null,
    private _duplicated: string = null,
    private _errorMsg: string = null,
    private _uuid: string = "",
    private _requestedBy?: string,
  ) {}

  get VoucherDate(): string {
    return this._voucherDate;
  }
  set VoucherDate(value: string) {
    this._voucherDate = value;
  }
  get Voucher(): string {
    return this._voucher;
  }
  set Voucher(value: string) {
    this._voucher = value;
  }
  get WhatasppLink(): string {
    return this._whatasppLink;
  }
  set WhatasppLink(value: string) {
    this._whatasppLink = value;
  }
  get Phone(): string {
    return this._phone;
  }
  set Phone(value: string) {
    this._phone = value;
  }
  get Timestamp(): string {
    return this._timestamp;
  }
  set Timestamp(value: string) {
    this._timestamp = value;
  }
  get Checker(): string {
    return this._checker;
  }
  set Checker(value: string) {
    this._checker = value;
  }
  get Proceed(): string {
    return this._proceed;
  }
  set Proceed(value: string) {
    this._proceed = value;
  }
  get Remark(): string {
    return this._remark;
  }
  set Remark(value: string) {
    this._remark = value;
  }
  get Ticket(): string {
    return this._ticket;
  }
  set Ticket(value: string) {
    this._ticket = value;
  }
  get CashInOffice(): string {
    return this._cashInOffice;
  }
  set CashInOffice(value: string) {
    this._cashInOffice = value;
  }
  get LineAmount(): number {
    return this._lineAmount;
  }
  set LineAmount(value: number) {
    this._lineAmount = value;
  }
  get Duplicated(): string {
    return this._duplicated;
  }
  set Duplicated(value: string) {
    this._duplicated = value;
  }
  get ErrorMsg(): string {
    return this._errorMsg;
  }
  set ErrorMsg(value: string) {
    this._errorMsg = value;
  }
  get Uuid(): string {
    return this._uuid;
  }
  set Uuid(value: string) {
    this._uuid = value;
  }
  get RequestedBy(): string {
    return this._requestedBy;
  }
  set RequestedBy(value: string) {
    this._requestedBy = value;
  }
  get CustomerName(): string {
    return this._customerName;
  }
  set CustomerName(value: string) {
    this._customerName = value;
  }
  get AccountDetails(): string {
    return this._accountDetails;
  }
  set AccountDetails(value: string) {
    this._accountDetails = value;
  }
  get GlCode(): string {
    return this._glCode;
  }
  set GlCode(value: string) {
    this._glCode = value;
  }
  get BranchName(): string {
    return this._branchName;
  }
  set BranchName(value: string) {
    this._branchName = value;
  }
  get OtherBankMaster(): any {
    return this._otherBankMaster;
  }
  set OtherBankMaster(value: any) {
    this._otherBankMaster = value;
  }
  get MbbMaster(): any {
    return this._mbbMaster;
  }
  set MbbMaster(value: any) {
    this._mbbMaster = value;
  }
  get Maker(): string {
    return this._maker;
  }
  set Maker(value: string) {
    this._maker = value;
  }
  get FormJCompany(): string {
    return this._formJCompany;
  }
  set FormJCompany(value: string) {
    this._formJCompany = value;
  }
  get BankCode(): string {
    return this._bankCode;
  }
  set BankCode(value: string) {
    this._bankCode = value;
  }
  get BankName(): string {
    return this._bankName;
  }
  set BankName(value: string) {
    this._bankName = value;
  }
  get Type(): string {
    return this._type;
  }
  set Type(value: string) {
    this._type = value;
  }
}
